import {QuestionsItemInterface} from "@/models/Question";

export enum EnumTextVoz {
    TEXTO_A_VOZ = 'TEXTO A VOZ',
    VOZ = 'VOZ',
    VOZ_A_TEXTO = 'VOZ A TEXTO',
}

export enum EnumType {
    NINOS = 'NIÑOS',
    ADULTOS = 'ADULTOS'
}

export interface FileActivity {
    name?: string;
    path: string;
    type: string;
    size: number;
}

export interface ActivityItemInterface {
    title?: string;
    activityQuestion: QuestionsItemInterface;
    question: string | string[];
    response: string | boolean | string[] | number | any;
    key?: string | number | string[] | any[] | any;
    note?: string;
    english?: boolean;
    file?: FileActivity;
    text?: EnumTextVoz;
    newResponse?:  string | boolean | string[] | number | any;
    createdAt?: any;
}

export interface ActivityInterface {
    id?: string;
    exam: boolean;
    title: string;
    order: number;
    activities?: ActivityItemInterface[];
    createdAt?: any;
}

export interface ActivityCategoryInterface {
    id?: string;
    title: string;
    createdAt?: any;
}

export interface ActivitySubCategoryInterface {
    id?: string;
    title: string;
    category: ActivityCategoryInterface;
    createdAt?: any;
}

export interface ActivityClassInterface {
    id?: string;
    createdAt?: any;
    subCategory: ActivitySubCategoryInterface;
    type: EnumType;
    background?: string;
}